import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "typeface-inter";

import i18n from "./translations/i18n/i18n";

import "./fonts/Sarabun-Regular-normal";
import "./fonts/Sarabun-Bold-bold";
import "./fonts/AngsanaNew-Regular";
import "./fonts/AngsanaNew-Bold";
import "./fonts/Tahoma-Regular-normal";
import "./fonts/Tahoma-Bold-bold";

import { GoogleOAuthProvider } from "@react-oauth/google";

import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
} from "@mui/material/styles";
import { I18nextProvider } from "react-i18next";

let theme = createTheme({
  typography: {
    fontFamily: ["Noto Sans Thai"].join(","),
  },
  responsiveFontSizes: true,
  palette: {
    fontSize: "small",
  },
});
theme = responsiveFontSizes(theme);
export const browserHistory = createBrowserHistory();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <React.StrictMode>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          <I18nextProvider i18n={i18n}>
            <App />
          </I18nextProvider>
        </GoogleOAuthProvider>
      </React.StrictMode>
    </ThemeProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
